<div class="confirm-identity-dialog">

  <!-- Header -->
  <div class="dialog-header">
    <h2 mat-dialog-title class="dialog-title">{{'kyc.notification' | translate}}</h2>
    <button type="button" class="close-btn" aria-label="Close" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <!-- Body -->
  <div mat-dialog-content class="dialog-body">
    <div class="icon-wrapper">
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="24" fill="#FDE6EB"/>
        <path d="M24 20V24M24 28H24.01M34 24C34 29.5228 29.5228 34 24 34C18.4772 34 14 29.5228 14 24C14 18.4772 18.4772 14 24 14C29.5228 14 34 18.4772 34 24Z"
              stroke="#EE2B3F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    
    <p class="dialog-message" *ngIf="data === 'EKYC'">
      {{'kyc.vneid_verification_regulation_ekyc' | translate}}
    </p>
    <p class="dialog-message" *ngIf="data !== 'EKYC'">
      {{'kyc.vneid_verification_regulation_notice' | translate}}
    </p>
  </div>

  <!-- Footer -->
  <div mat-dialog-actions class="dialog-actions">
    <button type="button" class="btn btn-outline" (click)="onNoClick()">
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 8L8 14M8 8L14 14M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" stroke="#EE0033" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>{{'kyc.cancel' | translate}}</span>
    </button>

    <button type="button" class="btn btn-filled" [mat-dialog-close]="true">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.16602 12.5H6.66602C5.11288 12.5 4.33631 12.5 3.72374 12.7537C2.90698 13.092 2.25806 13.741 1.91975 14.5577C1.66602 15.1703 1.66602 15.9469 1.66602 17.5M12.916 2.7423C14.1376 3.23679 14.9993 4.43443 14.9993 5.83333M9.99924 17.9167L11.6868 17.5792C11.834 17.5497 11.9075 17.535 11.9761 17.5081C12.037 17.4842 12.0949 17.4533 12.1485 17.4158C12.209 17.3737 12.262 17.3206 12.3681 17.2145L17.9161 11.6667C18.3763 11.2065 18.3763 10.4602 17.916 9.99998C17.4558 9.53975 16.7096 9.53976 16.2494 10L10.7014 15.5479C10.5954 15.654 10.5423 15.707 10.5002 15.7675C10.4627 15.8211 10.4318 15.879 10.4079 15.9399C10.381 16.0085 10.3663 16.082 10.3368 16.2292L9.99924 17.9167ZM11.2493 5.83333C11.2493 7.67428 9.75696 9.16667 7.91602 9.16667C6.07507 9.16667 4.58268 7.67428 4.58268 5.83333C4.58268 3.99238 6.07507 2.5 7.91602 2.5C9.75696 2.5 11.2493 3.99238 11.2493 5.83333Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>{{'kyc.vneid_authentication' | translate}}</span>
    </button>
  </div>

</div>